<swiper class="cities" [config]="citiesSwiperConfig">
  <ng-template swiperSlide *ngFor="let state of states let i = index">
    <div class="card bg-grad" (click)="selectedState(state)">
      <span class="uf">{{state.uf}}</span>
      <p class="text-center text-dark text-uppercase m-0">{{ state.name }}</p>
    </div>
  </ng-template>
</swiper>
